<script lang="ts">
    import {createEventDispatcher} from "svelte";
    import {UrlUtil} from "../../../lib/Common/Http/UrlUtil";
    import {HttpRequestUtil} from "../../../lib/Common/Http/HttpRequestUtil";
    import EditDialogView from "../../../component/common/Dialog/EditDialogView.svelte";
    import PortalView from "../../../component/common/Portal/PortalView.svelte";
    import InputAreaView from "../../../component/common/Form/InputAreaView.svelte";


    const dispatcher = createEventDispatcher();

    export let editData;


    function close() {
        dispatcher('close');
    }

    function save() {


        const url = UrlUtil.createApiUrl("space");

        HttpRequestUtil.postRequest(url, editData, (response) => {
            console.log(response);
            const body = response['body'];

            dispatcher('update');
            close();

        });
    }

    function onShow() {
        console.log({editData});


    }

    function onDelete() {
        const url = UrlUtil.createApiUrl("space");

        HttpRequestUtil.deleteRequest(url, editData, (response) => {
            console.log(response);
            const body = response['body'];

            dispatcher('update');
            close();

        });
    }

</script>

<PortalView>
    <EditDialogView editData={editData} on:save={save} on:cancel={close} title="スペース編集"
                    on:show={onShow}
                    on:delete={onDelete}
    >
        <div class="space-edit-content">
            <div>
                <InputAreaView label="スペース名">
                    <input type="text" bind:value={editData.name}
                           placeholder="スペース名" required
                    />
                </InputAreaView>

                <InputAreaView label="ユニークID">
                    <input type="text" bind:value={editData.unique_id}
                           placeholder="ユニークID" required
                    />
                </InputAreaView>
            </div>

            <div>
                <InputAreaView label="説明">
                    <input type="text" bind:value={editData.description}
                           class="description"
                           placeholder="説明"
                    />
                </InputAreaView>
            </div>

            <div>
                <InputAreaView label="Access Token">
                    <input type="text" bind:value={editData.access_token}
                           placeholder="Access Token" required
                    />
                </InputAreaView>
            </div>

            <div>
                <fieldset>
                    <legend>Git設定</legend>

                    <InputAreaView label="Git Web Url">
                        <input type="text" bind:value={editData.git_web_url}
                               class="git-web-url"
                               placeholder="Git Web Url" required
                        />
                    </InputAreaView>

                    <InputAreaView label="Git Ssh Url">
                        <input type="text" bind:value={editData.git_ssh_url}
                               class="git-ssh-url"
                               placeholder="Git Ssh Url" required
                        />
                    </InputAreaView>

                </fieldset>
            </div>


            <div>


                <fieldset>
                    <legend>Slack設定</legend>

                    <div>
                        <InputAreaView label="Slack Notice Token">
                            <input type="text" bind:value={editData.slack_notice_token}
                                   placeholder="Slack Notice Token"
                            />
                        </InputAreaView>

                        <InputAreaView label="Slack Notice Channel Id">
                            <input type="text" bind:value={editData.slack_notice_channel_id}
                                   placeholder="Slack Notice Channel Id"
                            />
                        </InputAreaView>

                    </div>


                </fieldset>

            </div>


        </div>


    </EditDialogView>
</PortalView>


<style lang="scss">
    .space-edit-content {
        display: flex;
        gap: 12px;
        flex-direction: column;
        width: 90vw;

        .description {
            width: 32em;
        }

        .git-web-url {
            width: 32em;
        }

        .git-ssh-url {
            width: 32em;
        }

    }

</style>